import {RESET_FORM, SET_FORM, SEND_FORM , FORM_ERROR} from './types'
import axios from 'axios'
// api.ptidej.bakasable.fr
const URL_API = "http://api.ptidej.bakasable.fr"
// const URL_API = "http://ptidej.bakasable.fr"

export function sendForm(data){
  const url = '/form';
  const headers = {};

  return function(dispatch){
    axios.post(URL_API+url, data)
      .then((response) => {
        dispatch({
          type: SEND_FORM,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FORM_ERROR,
          payload: error.response,
        });
      });
  }


}

export function resetForm(data){
  return dispatch => dispatch({
    type: RESET_FORM,
  });
}

export function setForm(data){
  return dispatch => dispatch({
    type: SET_FORM,
    payload: data,
  });
}



// WEBPACK FOOTER //
// ./src/client/actions/formulaire.js